import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));

// PRODUCT
const ProductPage = lazy(() => import('src/pages/dashboard/product/list'));

// ORDER
const OrderListPage = lazy(() => import('src/pages/dashboard/order/list'));
const OrderDetailsPage = lazy(() => import('src/pages/dashboard/order/details'));

const SponsorListPage = lazy(() => import('src/pages/dashboard/sponsor/list'));

const VeteranListPage = lazy(() => import('src/pages/dashboard/veteran/list'));
const CommunityListPage = lazy(() => import('src/pages/dashboard/community/list'));
const DonorListPage = lazy(() => import('src/pages/dashboard/donor/list'));
const SignListPage = lazy(() => import('src/pages/dashboard/sign/list'));
const ShirtListPage = lazy(() => import('src/pages/dashboard/shirt/list'));
const GolfListPage = lazy(() => import('src/pages/dashboard/golf/list'));
const GolfCreateTeam = lazy(() => import('src/pages/dashboard/golf/GolfCreateTeam'));
const PeopleView = lazy(() => import('src/pages/dashboard/people/PeopleView'));
const PeopleCreateSponsor = lazy(() => import('src/pages/dashboard/people/PeopleCreateSponsor'));

const CalendarPage = lazy(() => import('src/pages/dashboard/calendar'));
const EventListPage = lazy(() => import('src/pages/dashboard/eventlist'));
const PicturesPage = lazy(() => import('src/pages/dashboard/pictures'));
const DevicesPage = lazy(() => import('src/pages/dashboard/devices'));

const PermissionDeniedPage = lazy(() => import('src/pages/dashboard/permission'));
// BLANK PAGE
const BlankPage = lazy(() => import('src/pages/dashboard/blank'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      {
        path: 'product', element: <ProductPage/>
      },
      {
        path: 'sponsor', element: <SponsorListPage />
      },
      {
        path: 'veteran', element: <VeteranListPage />
      },
      {
        path: 'community', element: <CommunityListPage />
      },
      {
        path: 'donor', element: <DonorListPage />
      },
      {
        path: 'sign', element: <SignListPage />
      },
      {
        path: 'shirt', element: <ShirtListPage />
      },
      {
        path: 'golfteam', element: <GolfListPage />
      },
      {
        path: 'pictures', element: <PicturesPage />
      },
      {
        path: 'devices', element: <DevicesPage />
      },
      { path: 'golfteam/newteam', element: <GolfCreateTeam /> },
      { path: 'people/:type/:id/:role', element: <PeopleView /> },
      { path: 'people/newsponsor', element: <PeopleCreateSponsor /> },
      {
        path: 'order',
        children: [
          { element: <OrderListPage />, index: true },
          { path: 'list', element: <OrderListPage /> },
          { path: ':id', element: <OrderDetailsPage /> },
        ],
      },
      { path: 'calendar', element: <CalendarPage /> },
      { path: 'event', element: <EventListPage /> },
      { path: 'permission', element: <PermissionDeniedPage /> },
      { path: 'blank', element: <BlankPage /> },
    ],
  },
];
